module.exports = __webpack_public_path__ + "static/media/logo-right-lg.c52d1f50.png";